import FocusableIconButton from '@components/FocusableIconButton';
import { userPaymentCompleteContext } from '@context/Payment/PaymentComplete';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';
import { TREATMENT_HISTORY_DETAIL, PRESCRIPTION, HOME } from '../focuskey';

import * as styles from './styles';

const PaymentCompleteView = () => {
  const {
    isPrescriptionExists,
    setButtonFocus,
    goTreatmentHistoryDetail,
    goPrescription,
    goHome
  } = userPaymentCompleteContext();

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.title}>진료비 결제가 완료되었어요.</div>
        <div css={styles.buttonContainer}>
          <FocusableIconButton
            iconType="arrow"
            buttonStyle={styles.button}
            focusKey={TREATMENT_HISTORY_DETAIL}
            onEnterPress={goTreatmentHistoryDetail}
          >
            진료내역 보기
          </FocusableIconButton>
          <FocusableIconButton
            iconType="arrow"
            buttonStyle={styles.button}
            focusKey={isPrescriptionExists === 'true' ? PRESCRIPTION : HOME}
            onEnterPress={isPrescriptionExists === 'true' ? goPrescription : goHome}
          >
            {isPrescriptionExists === 'true' ? '처방약 받기' : '홈으로'}
          </FocusableIconButton>
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PaymentCompleteView;
